import type { WidgetCoreDefinition, TeXMLContext, TeXMLElement, ValidationResult } from './types';
import { buildCallbackUrl } from './types';

export type TransferToAgentConfig = {
  memberId: string;
  memberName: string;
  ringTimeoutSecs: number;
  fallbackAction: 'voicemail' | 'hangup' | 'continue';
};

function generateTeXML(config: TransferToAgentConfig, context: TeXMLContext): TeXMLElement[] {
  return [
    {
      tag: 'Redirect',
      attributes: { method: 'POST' },
      content: buildCallbackUrl(context),
    },
  ];
}

function validateConfig(config: TransferToAgentConfig): ValidationResult {
  const errors: string[] = [];

  if (!config.memberId) {
    errors.push('Agent is required');
  }

  if (config.ringTimeoutSecs < 5 || config.ringTimeoutSecs > 120) {
    errors.push('Ring timeout must be between 5 and 120 seconds');
  }

  return { valid: errors.length === 0, errors };
}

export const transferToAgentWidgetCore: WidgetCoreDefinition<TransferToAgentConfig> = {
  id: 'transferToAgent',
  version: 1,
  name: 'Transfer to Agent',
  description: "Route the call to a specific agent's softphone",
  category: 'routing',
  tier: 'premium',

  defaultConfig: {
    memberId: '',
    memberName: '',
    ringTimeoutSecs: 30,
    fallbackAction: 'continue',
  },

  texml: {
    generate: generateTeXML,
    requiresCallback: true,
  },

  validation: {
    validateConfig,
  },
};
